import MTagsWrapper from '@/components/MTagsWrapper/MTagsWrapper.vue';

export { MTagsWrapper };
export default MTagsWrapper;
